export const VISIBLE_TYPE = 'visible';
export const MANDATORY_TYPE = 'mandatory';
export const SECOND_SET_KEY_PARAM_VALUE_MAP: Record<string, string> = {
  secondSetComplete: 'COMPLETE_SET',
  secondSetOnlyRims: 'RIMS_ONLY',
  secondSetOnlyPneus: 'TIRES_ONLY',
};
